/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {
    import fld = PDCClearanceDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class PDCClearanceDetailsEditor extends _Ext.GridEditorBase<PDCClearanceDetailsRow> {
        protected getColumnsKey() { return "Finance.PDCClearanceDetails"; }
        protected getDialogType() { return PDCClearanceDetailsDialog; }
        protected getLocalTextPrefix() { return PDCClearanceDetailsRow.localTextPrefix; }
        protected getInsertPermission() { return PDCClearanceDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PDCClearanceDetailsRow.updatePermission; }
        protected getDeletePermission() { return PDCClearanceDetailsRow.deletePermission; }
        protected useViewMode() { return true; }
        private pendingChanges: Q.Dictionary<any> = {};
        public rateid: string;
        public ratetype: string;
        public cols;
        protected form: PDCClearanceDetailsForm;
        amount = 0; markup = 0;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));

        }
        private autoSize;
        public getColumns() {

            var columns = super.getColumns();

            //Q.first(columns, x => x.field === fld.Status).format = num;
            var Status = Q.first(columns, x => x.field === fld.Status);
            Status.referencedFields = [fld.Status];
            Status.format = ctx => this.selectFormatter(ctx, fld.Status);


            this.view.refresh();
            this.cols = columns;//setting columns for master to filter
            return columns;
        }
        // inline delete event handler
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        //if (item.PriceListDetailsId > 0) {


                        //    PDCClearanceDetailsService.Delete({ EntityId: item.PriceListDetailsId });
                        //    this.view.deleteItem(id);
                        //    //this.view.refresh();

                        //}
                        //else {
                        //    var id = this.id(item);
                        //    this.view.deleteItem(id);
                        //}

                    });
                }
            }
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

      
        // Edit event handler
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;
            value = text;
            // *** Set Department ***
            if (field === fld.Status && value != "") {
                item[field] = value;

            }
            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }
        // **** for Dropdown in Gird ****
        private selectFormatter(ctx: Slick.FormatterContext, idField: string) {
            //TODO: To add in Translation
            var lookup = [{ id: 'Cleared', text: 'Cleared' }, { id: 'Bounced', text: 'Bounced' }, { id: 'Not Cleared', text: 'Not Cleared' }];
            var klass = 'edit';
            var item = ctx.item
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            var column = ctx.column as Slick.Column;

            if (pending && pending[idField] !== undefined) {
                klass += ' dirty';
            }

            var value = this.getEffectiveValue(item, idField);
            var markup = "<select class='" + klass +
                "' data-field='" + idField +
                "' style='width: 100%; max-width: 100%'>";
            for (var c of lookup) {
                let id = c.id;
                markup += "<option value='" + Q.attrEncode(id) + "'"
                if (id == value) {
                    markup += " selected";
                }
                markup += ">" + Q.htmlEncode(c.text) + "</option>";
            }
            return markup + "</select>";
        }

        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //protected getButtons() {
        //    return [];
        //}
        public setitems(vouchers: any[]) {
            var tmp = [];
            for (let item of vouchers) {
                item[this.getIdProperty()] = "`" + this.nextId++;
                tmp.push(item);
            }
            return tmp;
        }
    }
}